export default __webpack_public_path__ + "static/media/default.882d7ec9.png";